import Button from "./button";
import classes from "../classes";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function TableHeaderPreviousPage({ onClick, page, pageSize, totalItems }) {
  if (totalItems <= pageSize) {
    return null;
  }
  return (
    <div className="game-table_cell game-table_cell--nav">
      <Button
        className={classes({
          "tickets_nav": true,
          "tickets_nav--is-disabled": page === 1
        })}
        onClick={onClick}>
        <span className="dw-chevron-left" />
      </Button>
    </div>
  );
});
